/**
 * @file Contains components customization for Material UI
 */

import { Components } from '@mui/material';

import MuiAvatar from './MuiAvatar';
import MuiButton from './MuiButton';
import MuiChip from './MuiChip';
import MuiDrawer from './MuiDrawer';
import MuiFilledInput from './MuiFilledInput';
import MuiIconButton from './MuiIconButton';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPopover from './MuiPopover';
import MuiSvgIcon from './MuiSvgIcon';
import MuiTooltip from './MuiTooltip';

const components: Components = {
  MuiAvatar,
  MuiButton,
  MuiChip,
  MuiDrawer,
  MuiFilledInput,
  MuiIconButton,
  MuiOutlinedInput,
  MuiPopover,
  MuiSvgIcon,
  MuiTooltip,
};

export default components;
